import { render, staticRenderFns } from "./QrDescargas.vue?vue&type=template&id=7d5f06ac"
import script from "./QrDescargas.vue?vue&type=script&lang=js"
export * from "./QrDescargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports